<template>
  <div style="background: solid">
    <b>#{{ item.id }} </b>
    <span>{{ item.item_name }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
  }
}
</script>
<style>
</style>